import { PlusOutlined } from '@ant-design/icons';
import { Button, Form, FormItemProps } from 'antd';
import { AiOutlineMinusCircle } from 'react-icons/ai';
import { useTheme } from 'styled-components';

export const DynamicFormItem: React.FC<
	FormItemProps & { itemName: string | string[]; placeholder: string; btnText: string }
> = ({ itemName, placeholder, btnText, rules, label, children }) => {
	const theme = useTheme();

	return (
		<div className="d-flex flex-column">
			<Form.List name={itemName}>
				{(fields, { add, remove }, { errors }) => (
					<>
						{fields.map((field, index) => (
							<Form.Item label={index === 0 ? label || placeholder : ''} key={field.key}>
								<div className="d-flex align-items-center">
									<Form.Item rules={rules} className="mb-0 me-3 w-100" {...field}>
										{children}
									</Form.Item>
									<AiOutlineMinusCircle
										style={{ color: theme.TA_ERROR, cursor: 'pointer' }}
										size={25}
										onClick={() => remove(field.name)}
									/>
								</div>
							</Form.Item>
						))}
						<Form.Item>
							<Button
								className="d-flex align-items-center p-3"
								type="dashed"
								style={{ backgroundColor: 'rgba(0,0,0,0.05)' }}
								onClick={() => add()}
								icon={<PlusOutlined />}
							>
								{btnText}
							</Button>

							<Form.ErrorList errors={errors} />
						</Form.Item>
					</>
				)}
			</Form.List>
		</div>
	);
};
